/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_7_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We retain your personal information only for as long as necessary to provide our services and fulfill the purposes outlined in this policy. Account data is retained while your account is active. You may request deletion of your account and associated data at any time.`)
};

const es_privacy_section_7_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retenemos tu información personal solo durante el tiempo necesario para proveer nuestros servicios y cumplir los propósitos descritos en esta política. Los datos de cuenta se retienen mientras tu cuenta esté activa. Puedes solicitar la eliminación de tu cuenta y datos asociados en cualquier momento.`)
};

const de_privacy_section_7_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir bewahren Ihre persönlichen Daten nur so lange auf, wie es zur Bereitstellung unserer Dienste und zur Erfüllung der in dieser Richtlinie beschriebenen Zwecke erforderlich ist. Kontodaten werden aufbewahrt, solange Ihr Konto aktiv ist. Sie können jederzeit die Löschung Ihres Kontos und der zugehörigen Daten beantragen.`)
};

const nl_privacy_section_7_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We bewaren uw persoonlijke informatie alleen zo lang als nodig is om onze diensten te verlenen en de in dit beleid beschreven doeleinden te vervullen. Accountgegevens worden bewaard zolang uw account actief is. U kunt op elk moment verzoeken om verwijdering van uw account en bijbehorende gegevens.`)
};

const fr_privacy_section_7_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous conservons vos informations personnelles uniquement aussi longtemps que nécessaire pour fournir nos services et remplir les objectifs décrits dans cette politique. Les données de compte sont conservées tant que votre compte est actif. Vous pouvez demander la suppression de votre compte et des données associées à tout moment.`)
};

const it_privacy_section_7_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserviamo le tue informazioni personali solo per il tempo necessario a fornire i nostri servizi e adempiere alle finalità descritte in questa informativa. I dati dell’account vengono conservati finché il tuo account è attivo. Puoi richiedere la cancellazione del tuo account e dei dati associati in qualsiasi momento.`)
};

const pt_br2_privacy_section_7_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retemos suas informações pessoais apenas pelo tempo necessário para fornecer nossos serviços e cumprir os propósitos descritos nesta política. Os dados da conta são retidos enquanto sua conta estiver ativa. Você pode solicitar a exclusão da sua conta e dados associados a qualquer momento.`)
};

const pt_privacy_section_7_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retemos as suas informações pessoais apenas durante o tempo necessário para fornecer os nossos serviços e cumprir os objetivos descritos nesta política. Os dados da conta são mantidos enquanto a sua conta estiver ativa. Pode solicitar a eliminação da sua conta e dados associados a qualquer momento.`)
};

const ja_privacy_section_7_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービスの提供およびこのポリシーに記載された目的の達成に必要な期間のみ、個人情報を保持します。アカウントデータはアカウントがアクティブな間保持されます。いつでもアカウントおよび関連データの削除をリクエストできます。`)
};

const zh_privacy_section_7_text = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们仅在提供服务和实现本政策所述目的所需的期限内保留您的个人信息。账户数据在您的账户处于活跃状态期间保留。您可以随时请求删除您的账户及相关数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_7_text = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_7_text(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_7_text", locale)
	if (locale === "en") return en_privacy_section_7_text(inputs)
	if (locale === "es") return es_privacy_section_7_text(inputs)
	if (locale === "de") return de_privacy_section_7_text(inputs)
	if (locale === "nl") return nl_privacy_section_7_text(inputs)
	if (locale === "fr") return fr_privacy_section_7_text(inputs)
	if (locale === "it") return it_privacy_section_7_text(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_7_text(inputs)
	if (locale === "pt") return pt_privacy_section_7_text(inputs)
	if (locale === "ja") return ja_privacy_section_7_text(inputs)
	return zh_privacy_section_7_text(inputs)
};